import * as React from 'react';

import { QuestionTypes } from '@showbie-socrative/socrative-utils';

import { translate } from '~l10n/client';
import {
  IconMultipleChoice,
  IconShortAnswer,
  IconTrueFalse,
} from '~shared/components/icons/micro';

interface Props {
  questionType: QuestionTypes;
}

/**
 * Renders the correct icon for a given question type.
 */
export function ResultsQuestionTypeIcon({
  questionType,
}: Props): React.ReactElement {
  switch (questionType) {
    case QuestionTypes.MultipleChoice:
      return (
        <IconMultipleChoice
          title={translate('Multiple Choice')}
          titleId="multiple-choice"
        />
      );
    case QuestionTypes.TrueFalse:
      return (
        <IconTrueFalse
          title={translate('True or False')}
          titleId="true-or-false"
        />
      );
    case QuestionTypes.FreeResponse:
      return (
        <IconShortAnswer
          title={translate('Short Answer')}
          titleId="short-answer"
        />
      );
    default:
      // No icon (e.g., Matching) — safe no-op
      return null;
  }
}
